export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Старый пароль"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Новый пароль"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Подтверждение пароля"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сохранить"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["\"Новый пароль\" и \"Подтверждение пароля\" не совпадают."])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Изменение пароля"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Строка от 4 до 63 символов. Допустимы символы латинского алфавита, цифры и символы"])},
  "strength": {
    "0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пусто"])},
    "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Слабый"])},
    "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Средний"])},
    "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сильный"])}
  }
}